import styled from 'styled-components';
import theme from 'styles/theme';

export const ModalFooterStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .accept-button {
    background-color: ${theme.colors.bgGreen};
    color: white;
  }

  .decline-button {
    background-color: ${theme.colors.hostfullyOrange};
    color: white;
  }
`;
